import { Plugin, App } from 'vue';
import $resolvePlugin from './$resolve.plugin';
import vuetifyPlugin from './vuetify.config';

export default {
  install(app: App) {
    app.use(vuetifyPlugin).use($resolvePlugin);
  },
} as Plugin;
